// extracted by mini-css-extract-plugin
export var scrollArea = "_ne-0";